import { apiRequest } from "./interceptor";

// Vendor APIs
const getVendorById = (id = null) => apiRequest("get", `/vendors/${id}`);
const getVendorDashboard = () => apiRequest("get", "/vendors/dashboard");
const getLoanApplications = (vendorId) =>apiRequest("get", `/loan-applications/vendor/${vendorId}`);
const submitProfileData = (vendorId, formData) =>apiRequest("put", `/vendors/${vendorId}`, formData);

// Loan Application Status API
const updateLoanApplicationStatus = (loanApplicationId, status) => apiRequest("put", `/loan-applications/update-status?loan_application_id=${loanApplicationId}&status=${status}`);



// Places API
const getPlacesAutocomplete = (input) => apiRequest("get", `/places/autocomplete?input=${input}`);
const getPlaceDetails = (placeId) => apiRequest("get", `/places/details?placeId=${placeId}`); // Added this line


// Exporting functions to be used
export default {
  getVendorById,
  getVendorDashboard,
  getLoanApplications,
  submitProfileData,
  getPlacesAutocomplete,
  getPlaceDetails,
  updateLoanApplicationStatus
};
